module.exports = __webpack_public_path__ + "img/next_btn.fce9976c.png";